"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = addValidation;

function addValidation(profile, rules) {
  var allRules = [].concat(rules.personalFields, rules.businessFields);
  return allRules.map(function (field) {
    var _ref;

    return _ref = {}, _ref[field.name] = {
      value: field.display && profile[field.name] ? field.display(profile[field.name]) : profile[field.name]
    }, _ref;
  }).reduce(function (acc, cur) {
    return _extends({}, acc, cur);
  }, {});
}

module.exports = exports["default"];